import React from 'react';

const headerIcon1 = () => {
  return (
    <svg width="30" height="26" viewBox="0 1 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0049 19V17C16.0049 15.9391 15.5835 14.9217 14.8333 14.1716C14.0832 13.4214 13.0657 13 12.0049 13H5.00488C3.94402 13 2.9266 13.4214 2.17646 14.1716C1.42631 14.9217 1.00488 15.9391 1.00488 17V19"
        stroke="#565A5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50488 9C10.714 9 12.5049 7.20914 12.5049 5C12.5049 2.79086 10.714 1 8.50488 1C6.29574 1 4.50488 2.79086 4.50488 5C4.50488 7.20914 6.29574 9 8.50488 9Z"
        stroke="#565A5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0049 9L19.0049 11L23.0049 7"
        stroke="#565A5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default headerIcon1;
